import MainLayout from "../components/layouts/MainLayout";
import DancersComponent from "../components/dancer/DancersComponent";

const DancersPage = () => {
    return <>
        <MainLayout>
            <DancersComponent/>
        </MainLayout>
    </>
}

export default DancersPage